import { render } from "./error-page.vue?vue&type=template&id=63e1f2ef&lang=pug"
import script from "./error-page.vue?vue&type=script&lang=js"
export * from "./error-page.vue?vue&type=script&lang=js"

import "./error-page.vue?vue&type=style&index=0&id=63e1f2ef&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__